import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AchievementKey = 'kddi' | 'ericsson' | 'nokia' | 'tokyo';

interface Achievement {
  key: AchievementKey;
  url?: string;
}

// url が未設定の項目はリンクなしのテキストとして表示する
const achievements: Achievement[] = [
  {
    key: 'kddi',
    url: 'https://prtimes.jp/main/html/rd/p/000000008.000151358.html',
  },
  {
    key: 'ericsson',
    url: 'https://www.ericsson.com/en/portfolio/cross-portfolio/rapp-directory/a-z-directory/fyra-ran-optimizer-rapp',
  },
  {
    key: 'nokia',
    url: 'https://open-ecosystem.org/marketplace/channel/10143/product/4817',
  },
  {
    key: 'tokyo',
    url: 'https://prtimes.jp/main/html/rd/p/000000003.000151358.html',
  },
];

/** パートナー企業・行政との実績を箇条書きで一覧表示する */
const AchievementsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box mt={4} mb={6}>
      <Typography
        variant="h3"
        align="center"
        sx={{ fontSize: { xs: '7vw', sm: 32 } }}
        gutterBottom
      >
        {t('achievements.title')}
      </Typography>
      <Box component="ul" sx={{ pl: { xs: 3, sm: 4 }, my: 3 }}>
        {achievements.map((item) => (
          <Box component="li" key={item.key} sx={{ mb: 3 }}>
            <Typography
              component="h3"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1rem', sm: '1.15rem' },
                lineHeight: 1.6,
              }}
            >
              【{t(`achievements.${item.key}.org`)}】
              {t(`achievements.${item.key}.ttl`)}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.9rem',
                color: 'secondary.main',
                pl: 1,
              }}
            >
              ・
              {item.url ? (
                <Link
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="secondary"
                  underline="hover"
                >
                  {t(`achievements.${item.key}.desc`)}
                </Link>
              ) : (
                t(`achievements.${item.key}.desc`)
              )}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AchievementsSection;
